import React, { Component } from 'react';
import ReactTable from 'react-table'
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import './StatisticsTable.css';
import 'react-table/react-table.css';

class StatisticsTable extends Component {
  render() {
    const columnHeaders = this.props.statistics.sort((a, b) => a.order - b.order);
    const values = this.props.data.map(x => ({ id: x.key, ...x.values[0] }));

    const columns = [
      {
        Header: 'Asset Class',
        accessor: 'id',
        minWidth: 20,
        Cell: props => <a onClick={() => this.props.onSelected('asset', props.value)}>{props.value}</a>
      },
      ...Array.from(columnHeaders).map(h => ({
        Header: props => <a onClick={() => this.props.onSelected(h.isReturn ? 'returnStatistic' : 'riskStatistic', h.statistic)}>{h.statistic}</a>,
        accessor: h.statistic,
        minWidth: 10,
        Cell: props => <div className="value">{d3.format('.1f')(props.value)}</div>
      })),
    ];

    return (
      <div style={{ width: '100%', overflow: 'auto' }} >
        <ReactTable
          className="statistics-table -striped"
          style={{ height: this.props.height }}
          data={values}
          columns={columns}
          showPagination={false}
        />
      </div>
    );
  }
}

export default withTitle(StatisticsTable);


// WEBPACK FOOTER //
// ./src/charts/StatisticsTable.js